import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlgoliaInstantSearch from './AlgoliaInstantSearch';
import './FeaturedProfiles.scss';
var FeaturedProfiles = /*#__PURE__*/function (_Component) {
  function FeaturedProfiles(props) {
    var _this;
    _classCallCheck(this, FeaturedProfiles);
    _this = _callSuper(this, FeaturedProfiles, [props]);
    _this.state = {
      email: props.email
    };
    _this.handleUserSignUp = _this.handleUserSignUp.bind(_this);
    _this.emailStatus = _this.emailStatus.bind(_this);
    return _this;
  }
  _inherits(FeaturedProfiles, _Component);
  return _createClass(FeaturedProfiles, [{
    key: "handleUserSignUp",
    value: function handleUserSignUp(userEmail) {
      this.setState({
        email: userEmail
      });
    }
  }, {
    key: "emailStatus",
    value: function emailStatus() {
      var email = this.state.email;
      return email;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        userData = _this$props.userData,
        indexName = _this$props.indexName,
        agAppID = _this$props.agAppID,
        publicKey = _this$props.publicKey,
        csrfToken = _this$props.csrfToken,
        cloraEmployer = _this$props.cloraEmployer,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        signInUrl = _this$props.signInUrl,
        initialFilters = _this$props.initialFilters;
      return /*#__PURE__*/React.createElement(AlgoliaInstantSearch, {
        indexName: indexName,
        agAppID: agAppID,
        publicKey: publicKey,
        handleRegister: this.handleUserSignUp,
        getEmailStatus: this.emailStatus,
        csrfToken: csrfToken,
        userData: userData,
        cloraEmployer: cloraEmployer,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        signInUrl: signInUrl,
        initialFilters: initialFilters
      });
    }
  }]);
}(Component);
FeaturedProfiles.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  userData: PropTypes.shape({}),
  indexName: PropTypes.string.isRequired,
  agAppID: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
  cloraEmployer: PropTypes.bool,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  initialFilters: PropTypes.shape({})
};
FeaturedProfiles.defaultProps = {
  email: null,
  userData: {},
  cloraEmployer: false,
  initialFilters: null
};
export default FeaturedProfiles;